<template>
	<div>
		<table class="table table-borderless">
			<tbody>
				<tr>
					<td class="py-0">
						<I name="empty" class="mr-4" />
					</td>
					<td class="w-25 px-1 py-0">
						<p class="name text-secondary text-black-50 mt-4 mb-1">
							DOKUMENTMALL
						</p>
					</td>
					<td class="py-0"></td>
					<td class="w-75 px-1 py-0">
						<p class="name text-secondary text-black-50 mt-4 mb-1">OM MALLEN</p>
					</td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="trophy2" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<p class="title">Förenklad kassaflödesvärdering</p>
					</td>
					<td />
					<td class="w-75 p-1 pt-3 size4">
						<p class="">
							En förenklad kassaflödesvärdering baserad på bolagets fem senaste
							officiella bokslut. Möjlighet finns att ändra bolagets bransch
							respektive kalkylränta och därmed justera bolagsvärdet. Skapat
							dokument inkluderar Värderingsrapport (PDF), Lathund (PDF) samt
							Presentation.
						</p>
						<p class="">
							Rekommenderat pris för en värderingsrapport är 5 000 kr.
							Debitering för minst fyra timmar rekommenderas tillkomma vid
							presentation inför kund.
						</p>
					</td>
				</tr>
				<tr>
					<td colspan="4"><hr /></td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="aim" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<span class="heading">1. Välj bolag:</span>
					</td>
					<td></td>
					<td class="w-75 p-1 pb-4 pt-3">
						<CompanySelection
							:locked="editing"
							:disabled="editing"
							:disabledSource="editing"
							:company="company"
							:useLatest="true"
							:use-sie="true"
							:use-branch="false"
							@company="selectedCompany = $event"
							@source="selectedSource = $event"
							@branch="selectedBranch = $event"
						/>
					</td>
				</tr>
				<tr>
					<td class="p-1 pt-3">
						<I name="chart-growth" class="mr-4" />
					</td>
					<td class="w-25 p-1 pt-3">
						<div class="heading">2. Välj kalkylränta:</div>
					</td>
					<td class="p-2 pt-3"></td>
					<td
						v-if="selectedCompany && valuation"
						class="w-75 p-1 pt-3 pb-5"
					>
						<div v-if="hasWarnings()" class="w-75 p-1 pt-3 pb-5">
							<div
								class="row m-3"
								style="background-color: #e70407; border-radius: 16px; width: 800px; height: 120px;"
							>
								<PGroup icon="warning" icon-color="white" class="m-auto">
									<PValue class="text-white mt-2" type="small"
										>Modellen för kassaflödesvärdering är inte lämplig för
										bolaget</PValue
									>
								</PGroup>
							</div>
						</div>
						<div>
							<a @click="selectedEV = 1">
								<ValueSelection
									title="Defaultvärde"
									:value1="valuation.CAPM"
									:value2="valuation.CALCULATED_VALUE"
									:selected="selectedEV === 1"
								/>
							</a>
						</div>
						<div class="mt-4">
							<a @click="selectedEV = 2">
								<ValueSelection
									title="Välj egen kalkylränta"
									editable="true"
									@inc="stepCapm(1)"
									@dec="stepCapm(-1)"
									:value1="valuation2.CAPM"
									:offset1="valuation2.CAPM_OFFSET"
									:value2="valuation2.CALCULATED_VALUE"
									:selected="selectedEV === 2"
									@click="selectedEV = 2"
								/>
							</a>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<hr class="mt-4" />

		<table class="mt-4 table table-borderless">
			<tbody>
				<tr>
					<td width="240px" class="p-0 pt-2">
						<div
							@click="$emit('prev')"
							class="btn btn-outline-danger btn-block btn-lg cursor-pointer"
						>
							<template v-if="!editing"
								>RADERA UTKAST</template
							>
							<template v-else
								>AVBRYT ÄNDRINGAR</template
							>
						</div>
					</td>
					<td class="h3 text-center">&nbsp;</td>
					<td width="240px" class="p-0 pt-2">
						<div
							@click="create()"
							class="btn btn-outline-primary btn-block btn-lg cursor-pointer"
							:class="{ disabled: !canCreate() }"
						>
							<template v-if="!editing"
								>SKAPA DOKUMENT</template
							>
							<template v-else
								>UPPDATERA DOKUMENT</template
							>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
/* tslint:disable */

import ValueGroup from "@/views/ValueGroup.vue";
import ValueSelection from "@/views/ValueSelection";
import user from "@/store/modules/user";
import * as api from "@/store/api";
import CompanySelection from "@/components/CompanySelection";

export default {
	name: "CreateDocumentValuation",
	components: { ValueSelection, ValueGroup, CompanySelection },
	props: {
		doc: Object,
	},
	data() {
		return {
			selectedCompany: undefined,
			selectedSource: undefined,
			selectedBranch: undefined,
			selectedEV: 0,
			valuation: null,
			valuation2: null,
			company: null,
			documentId: "",
		};
	},
	async mounted() {
		if (this.editing) {
			const c = await user.getCompany(this.doc.OrgNr);

			if (c) {
				this.company = {
					value: c.OrgNr,
					label: c.Name,
					Branch: c.Bransch,
					BranchText: c.BranschText,
					dateTo: c.DateTo,
					SieAggVersion: this.doc.SieAggVersion,
				};
			}

			this.valuation = null;
			this.valuation2 = await api.getValuation(1, user.version, c.OrgNr);
			this.valuation = await api.getValuation(0, user.version, c.OrgNr);
			await this.stepCapm(this.doc.CAPM_OFFSET - 1);

			if (this.doc.CAPM_OFFSET === 0) {
				this.selectedEV = 1;
			} else {
				this.selectedEV = 2;
			}
		}
	},
	watch: {
		async selectedCompany() {
			this.valuation = null;
			if (this.selectedCompany) {
				this.valuation2 = await api.getValuation(
					1,
					user.version,
					this.selectedCompany.value
				);
				this.valuation = await api.getValuation(
					0,
					user.version,
					this.selectedCompany.value
				);
			}
		},
	},
	methods: {
		canCreate() {
			return (
				this.selectedCompany &&
				this.selectedEV !== 0 &&
				this.valuation
			);
		},
		hasWarnings() {
			return (
				this.valuation.warnings.length > 0 || this.valuation.errors.length > 0
			);
		},
		getOffset() {
			if (this.selectedEV === 1) {
				return 0;
			} else {
				return this.valuation2.CAPM_OFFSET;
			}
		},
		async create() {
			if (!this.canCreate()) return;
			let OrgNr = this.selectedCompany.value;
			const doc = {
				Type: "valuation",
				OrgNr: OrgNr,
				CAPM_OFFSET: this.getOffset(),
				DocumentId: this.editing ? this.doc.DocumentId : "",
			};
			if (this.editing) {
				await api.updateDocument(doc);
				await user.getUser("Uppdaterar dokument");
			} else {
				await api.addDocument(doc);
				await user.getUser("Skapar dokument");
			}
			this.$router.push({ name: "documents", params: { OrgNr } });
		},
		getCompanies() {
			return this.companies;
		},
		getBranches() {
			return [{ id: 1, label: "Branschen" }];
		},
		async stepCapm(step) {
			let capm =
				this.valuation2.CAPM * 100 + this.valuation2.CAPM_OFFSET + step;
			if (capm >= 8 && capm <= 50) {
				this.valuation2 = await api.getValuation(
					this.valuation2.CAPM_OFFSET + step,
					user.version,
					this.selectedCompany.value
				);
			}
		},
	},
	computed: {
		companies() {
			const x = user.companies;
			let res = [];
			for (let y in x) {
				let c = x[y];
				res.push({
					value: c.OrgNr,
					label: c.Name,
					bransch: c.Bransch,
					branschText: c.BranschText,
				});
			}
			res.sort((a, b) => {
				return ("" + a.label).localeCompare(b.label);
			});
			return res;
		},
		editing() {
			return this.$router.currentRoute.name === "editdocument";
		},
	},
};
</script>

<style scoped lang="scss">
.title {
	font-size: 1.5rem;
	font-weight: 600;
}
.name {
	font-size: 0.875rem;
	color: col("colors.DarkGrey");
	text-transform: uppercase;
	font-weight: 400;
}
.value {
	font-size: 1.25rem;
	font-weight: 400;
}
.heading {
	font-size: 1.5rem;
	font-weight: 300;
	color: col("colors.Black");
}
</style>
